import { Unit } from '../components/ServiceItem';
import { ExternalPatient, PatientProps } from '../contexts/PatientContext';
import { Patient, PatientScheduleBuilder } from './Patient';
import { Payment, ScheduleItemProps, ScheduleItemPropsBuilder } from './Schedule';
import { SchedulePayment, SchedulePaymentBuilder } from './SchedulePayment';

type ScheduleItem = {
  payment: SchedulePayment;
  isFirstAppointment?: boolean;
  serviceId?: string;
} & Pick<
  ScheduleItemProps,
  | 'itemId'
  | 'selectedSlotOptions'
  | 'careType'
  | 'idConvenio'
  | 'productName'
  | 'scheduleType'
  | 'productId'
  | 'unit'
  | 'catalogItemId'
>;
// itemId: string | number;
//   selectedSlotOptions: TimeSchedule[];
//   careType: string;
//   idConvenio?: string;
//   productName: string;
//   scheduleType: string;
//   productId: string;
//   unit: UnitAppointment;
//   catalogItemId: string;
//   payment: SchedulePayment;

export type ScheduleRequest = {
  patient: Patient;
  schedules: ScheduleItem[];
};

const ScheduleRequestBuilder = () => {
  const schedulePatient = {} as ScheduleRequest;

  function setPatient(patientSchedule: PatientProps, patientExternalId?: string) {
    const patient = PatientScheduleBuilder(patientSchedule.name);
    patient.setBirthDate(patientSchedule.birthDate);
    patient.setDocument(patientSchedule.document, patientSchedule.documentType);
    if (patientExternalId) patient.setExternalId(patientExternalId);
    patient.setEmail(patientSchedule.email);
    patient.setPhone(patientSchedule.phone);
    patient.setGender(patientSchedule.gender);
    patient.setIsPregnant(patientSchedule.pregnant);
    schedulePatient.patient = patient.build();
  }

  function setPayment(payment: Payment) {
    if (payment?.type) {
      const schedulePayment = SchedulePaymentBuilder(String(payment.type));
      if (payment.eligibility) {
        schedulePayment.setHelthInsuranceId(String(payment.eligibility?.idInsurance));
        schedulePayment.setPlanCode(payment.eligibility.codPlan);
        schedulePayment.setName(payment.healthInsurance?.name || payment.eligibility.plan);
      }
      return schedulePayment.build();
    }
  }

  function setSchedules({
    schedules,
    isFirstAppointment,
    serviceId
  }: {
    schedules: ScheduleItemProps[];
    isFirstAppointment?: boolean;
    serviceId?: string;
  }) {
    schedulePatient.schedules = schedules.map(item => {
      const scheduleBuild = ScheduleItemPropsBuilder(item);
      const schedule = scheduleBuild.validateSchedule();

      const scheduleItem = {} as ScheduleItem;

      scheduleItem.careType = schedule.careType;
      scheduleItem.catalogItemId = schedule.catalogItemId;
      scheduleItem.idConvenio = schedule.idConvenio;
      scheduleItem.itemId = schedule.itemId;

      if (schedule.payment) {
        const payment = setPayment(schedule.payment);

        if (payment) scheduleItem.payment = payment;
      }

      scheduleItem.productId = schedule.productId;
      scheduleItem.productName = schedule.productName;
      scheduleItem.scheduleType = schedule.scheduleType;
      scheduleItem.selectedSlotOptions = schedule.selectedSlotOptions;
      scheduleItem.unit = schedule.unit;

      scheduleItem.isFirstAppointment = isFirstAppointment;
      scheduleItem.serviceId = serviceId;

      return scheduleItem;
    });
  }

  const build = () => schedulePatient;

  return { setPatient, setSchedules, build };
};

export const createScheduleRequest = (
  patientSchedule: PatientProps,
  schedules: ScheduleItemProps[],
  units?: Unit[],
  isFirstAppointment?: boolean,
  serviceId?: string
) => {
  const scheduleRequest = ScheduleRequestBuilder();
  scheduleRequest.setPatient(patientSchedule);
  scheduleRequest.setSchedules({ schedules, isFirstAppointment, serviceId });
  return scheduleRequest.build();
};

export const createScheduleRequestPatientExternal = (
  patientSchedule: ExternalPatient,
  schedules: ScheduleItemProps[],
  isFirstAppointment?: boolean,
  serviceId?: string
) => {
  const scheduleRequest = ScheduleRequestBuilder();
  scheduleRequest.setPatient(patientSchedule as PatientProps, patientSchedule.idPatientExt);
  scheduleRequest.setSchedules({ schedules, isFirstAppointment, serviceId });
  return scheduleRequest.build();
};
